export enum EStackGroup {
  FixedVisitWithDay = 1,
  FixedVisitWithoutDay = 3,
  FixedHourWithDay = 4,
  FixedHourWithoutDay = 5,
  FlexibleHourWithDay = 6,
  FlexibleHourWithoutDay = 7,
  AllControls = 8,
}

export const stack_category = [
  { name: "Fixed per visit", id: "fixed_per_visit" },
  { name: "Fixed per hour", id: "fixed_per_hour" },
  { name: "Flexible per hour", id: "flexible_per_hour" },
];
export const currency_options = [
  { value: "KWD", label: "KWD" },
  { value: "BHD", label: "BHD" },
  { value: "SAR", label: "SAR" },
];
export const currency_options_ar = [
  { value: "ك.د", label: "ك.د" },
  { value: "ب.د", label: "ب.د" },
  { value: "ر.س", label: "ر.س" },
];
export const daysof_week = [
  { name: "Sunday", id: "sunday" },
  { name: "Monday", id: "monday" },
  { name: "Tuesday", id: "tuesday" },
  { name: "Wednesday", id: "wednesday" },
  { name: "Thursday", id: "thursday" },
  { name: "Friday", id: "friday" },
  { name: "Saturday", id: "saturday" },
];
export const parking_types = [
  {
    id: 1,
    label: "Public",
  },
  {
    id: 2,
    label: "Private",
  },
  {
    id: 3,
    label: "Pre-Booking",
  },
];
